import dashboard from 'assets/icons/dashboard.svg';
import profile from 'assets/icons/profile.svg';
import pipeline from 'assets/icons/pipeline.svg';
import documents from 'assets/icons/document.svg';
import tools from 'assets/icons/tools.svg';
import reportsIcon from 'assets/icons/reportsIcon.svg';
import adminIcon from 'assets/icons/adminIcon.svg';
import consumerIcon from 'assets/icons/consumerIcon.svg';
import quickPrice from 'assets/icons/quickPrice.svg';
import reports from 'assets/icons/reports.svg';
import admin from 'assets/icons/admin.svg';
import { canAccessSection, SECTIONS } from '../../utils/accessControl';
import { normalizeRole } from '../../utils/roles';

export const navItems = [
  {
    title: 'Dashboard',
    icon: <img src={dashboard} alt="dashboard"></img>,
    path: '/dashboard',
    role: [
      'consumer',
      'loanOfficer',
      'organization',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
      'underwriter',
      'closer',
      'auditor',
    ],
  },
  {
    title: 'Profile',
    icon: <img src={profile} alt="profile"></img>,
    path: '/profile',
    role: ['consumer'],
  },
  {
    title: 'Loan Information',
    icon: <img src={profile} alt="loan"></img>,
    path: '/loanInformation',
    role: ['loanOfficer', 'organization', 'superAdmin', 'branchAdmin', 'loanProcessor'],
    subPaths: ['/loanInformation'],
  },
  {
    title: 'Pipeline',
    icon: <img src={pipeline} alt="pipeline"></img>,
    path: '/pipeline',
    role: [
      'loanOfficer',
      'organization',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
      // Dashboard and Pipeline are the whole sidebar for these three. Not
      // Loan Information, which is the leads list and originating work, and
      // not Quick Price, Tools or Reports.
      'underwriter',
      'closer',
      'auditor',
    ],
    subPaths: ['/pipeline'],
  },
  {
    title: 'My Applications',
    icon: <img src={pipeline} alt="pipeline"></img>,
    path: '/pipeline',
    role: ['consumer'],
    subPaths: ['/pipeline'],
  },
  {
    title: 'Quick Price',
    icon: <img src={quickPrice} alt="quickPrice"></img>,
    path: '/quickPrice',
    role: ['loanOfficer', 'organization', 'superAdmin', 'branchAdmin'],
  },
  {
    title: 'Documents',
    icon: <img src={documents} alt="documents"></img>,
    path: '/documents',
    role: ['consumer'],
  },
  {
    title: 'Tools',
    icon: <img src={tools} alt="tools"></img>,
    path: '/tools',
    role: [
      'consumer',
      'organization',
      'loanOfficer',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
    ],
  },
  {
    title: 'Admin',
    icon: <img src={admin} alt="admin"></img>,
    path: '/admin/employees',
    subPaths: ['/admin', '/admin/consumer', '/admin/employees', '/admin/branches', '/admin/invitations'],
    section: SECTIONS.ADMIN,
  },
  {
    title: 'Reports',
    icon: <img src={reports} alt="reports"></img>,
    path: '/reports',
    role: ['organization', 'superAdmin', 'branchAdmin'],
  },
];
